import { useMemo } from 'react';

import getEditorSchema from '@/components/PageEditor/schema';
import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';

import { CourseLessonPage } from '../../course/Extensions/@ly';

const useArticleEditorViewProps = () => {
  const { [FeatureFlags.DefaultRestricted]: isDefaultRestricted } = useFeatureFlags();

  return useMemo(
    () => getEditorSchema([CourseLessonPage], { isDefaultRestricted }),
    [isDefaultRestricted],
  );
};

export default useArticleEditorViewProps;
